import React, { useEffect } from "react";
import { FaCheckCircle, FaBullhorn, FaDesktop, FaMobileAlt, FaEnvelope } from "react-icons/fa";
import "../sell-fast-page/info-page.css";
import {
  EMAIL,
} from "../../../configs/website-information/websiteInfo";

const PLACEMENTS = [
  {
    icon: <FaDesktop size={22} color="#ed1b24" />,
    title: "Landing Page Banner",
    desc: "A prominent banner displayed at the top of the AdsOne homepage — the highest-traffic page on the platform, seen by every visitor.",
  },
  {
    icon: <FaMobileAlt size={22} color="#ed1b24" />,
    title: "Listing Page Banner",
    desc: "Your banner displayed within the vehicle listings page, reaching buyers who are actively browsing and ready to purchase.",
  },
  {
    icon: <FaBullhorn size={22} color="#ed1b24" />,
    title: "Ad Detail Page",
    desc: "Reach buyers at the highest point of intent — while they are viewing a specific vehicle listing and considering their options.",
  },
];

function BannerAdsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          <div className="info-page__hero">
            <p className="info-page__eyebrow">Advertise with Us</p>
            <h1 className="info-page__title">Banner Advertising on AdsOne</h1>
            <p className="info-page__subtitle">
              Reach thousands of active vehicle buyers across Sri Lanka. Place your brand where purchase decisions are made.
            </p>
          </div>

          <div className="info-page__body">

            <div className="info-section" style={{ flexDirection: "column", gap: "0.5rem" }}>
              <h3 className="info-section__title">Why Advertise on AdsOne?</h3>
              <ul className="info-section__list">
                {[
                  "Access a highly targeted audience of vehicle buyers and sellers across Sri Lanka.",
                  "Your banner is displayed to users who are already in a buying mindset.",
                  "Multiple placement options to suit your budget and campaign goals.",
                  "Simple setup — our team handles everything from design guidance to placement.",
                ].map((p, i) => (
                  <li key={i}>
                    <FaCheckCircle size={13} color="#22c55e" style={{ flexShrink: 0, marginTop: 2 }} />
                    {p}
                  </li>
                ))}
              </ul>
            </div>

            <div className="row g-3">
              {PLACEMENTS.map((p, i) => (
                <div key={i} className="col-sm-12 col-md-4">
                  <div className="info-section" style={{ flexDirection: "column", height: "100%" }}>
                    <div className="info-section__icon-wrap">{p.icon}</div>
                    <div className="info-section__content">
                      <h3 className="info-section__title">{p.title}</h3>
                      <p style={{ fontSize: "0.9rem", color: "#475569", margin: 0, lineHeight: 1.6 }}>{p.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="info-section" style={{ flexDirection: "column", gap: "0.5rem", background: "#fafafa" }}>
              <h3 className="info-section__title">Get in Touch</h3>
              <p style={{ fontSize: "0.9rem", color: "#475569", margin: 0 }}>
                Contact our team to discuss placement options, pricing and campaign requirements. We will get back to you within one business day.
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", marginTop: "0.5rem" }}>
                <a href={`mailto:${EMAIL}`} style={{ display: "flex", alignItems: "center", gap: "0.4rem", color: "#ed1b24", fontWeight: 600, textDecoration: "none", fontSize: "0.9rem" }}>
                  <FaEnvelope size={14} /> {EMAIL}
                </a>
              </div>
            </div>

          </div>

          <div className="info-page__cta">
            <h3>Interested in advertising?</h3>
            <p>Get in touch and our team will help you find the right placement for your brand.</p>
          </div>

        </div>
      </div>
    </div>
  );
}

export default BannerAdsPage;
